import { createContext } from 'react';
import { Guild } from '../types';

type PlayerContextType = {
  playerGuild?: Guild;
  updatePlayerGuild: (guild: Guild) => void;
};

export const PlayerContext = createContext<PlayerContextType>({
  updatePlayerGuild: () => {},
});